module.exports = "<header>\r\n  <div class=\"kng-header {{additionalClasses}}\" [ngClass]=\"{'kng-header-with-bottom-line': showBottomLine}\">\r\n    <div class=\"kng-header-title kng-text-ellipsis\">{{title}}</div>\r\n    <i ng-if=\"includeBack\" class=\"kng-icon kng-icon-int-back kng-header-back-icon\" ng-click=\"onBack()\"></i>\r\n    <ng-content></ng-content>\r\n  </div>\r\n</header>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/layout/kingswell/kng-header/kng-header.component.html
// module id = ../../../../../src/app/layout/kingswell/kng-header/kng-header.component.html
// module chunks = main